import {
  display,
  space,
  width,
  maxWidth,
  minWidth,
  flex,
  alignSelf,
  border,
  borderColor,
  SpaceProps,
  WidthProps,
  MaxWidthProps,
  MinWidthProps,
  FlexProps,
  JustifyContentProps,
  AlignItemsProps,
  FlexWrapProps,
  AlignSelfProps,
  BorderProps,
  FlexDirectionProps,
  color,
  borderRadius,
  BorderRadiusProps,
  borders,
  DisplayProps,
  HeightProps,
  height,
  FontSizeProps,
  fontSize,
  BorderColorProps
} from "styled-system";
import { styled, ThemedColorProps } from "styles";

type Props = DisplayProps &
  SpaceProps &
  WidthProps &
  HeightProps &
  MaxWidthProps &
  MinWidthProps &
  FlexProps &
  AlignSelfProps &
  BorderProps &
  ThemedColorProps &
  BorderRadiusProps &
  BorderProps &
  FontSizeProps &
  BorderColorProps;

const TextInput = styled<Props, "input">("input").attrs({
  type: "text"
} as any)`
    ${display}

    ${space}
    ${width}
    ${maxWidth}
    ${minWidth}
    ${height}

    ${flex}
    ${alignSelf}


    ${borderRadius}
    ${borders}
    ${borderColor}


    ${color}
    ${fontSize}


    &:focus{
      outline: none!important;
    }
`;

TextInput.defaultProps = {
  p: 1,
  fontSize: 2,
  borderRadius: "10px",
  height: "4rem",
  border: "1px solid",
  borderColor: "black"
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/ui/TextInput.tsx